import {AfterViewInit, ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {OccupationalProfile} from '../shared/occupational-profile';
import {Config} from '../shared/orientationtest-config/config';

// @ts-expect-error brpchart is a global provided by an external script
declare const brpchart;

@Component({
    selector: 'occupational-profile-charts',
    templateUrl: './occupational-profile-charts.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileChartsComponent implements AfterViewInit {

    @Input()
    public occupationalProfile!: OccupationalProfile;
    @Input()
    public config!: Config;

    errorState = false;

    showChart(brpchartEnvironment: string | null, monitoringCode: string): void {
        this.errorState = false;
        const errorCallback = (errorMessage: string) => {
            console.error(`Error loading charts: ${errorMessage}`);
            this.errorState = true;
        };
        brpchart.f_show_chart(monitoringCode,
            brpchartEnvironment,
            'id_div_chart_1',
            '',
            'id_div_chart_2',
            '',
            'id_div_chart_3',
            'id_a_chart_3',
            'id_div_chart_4',
            '',
            errorCallback
        );
    }

    ngAfterViewInit(): void {
        if (this.shouldShowCharts()) {
            this.showChart(this.config.brpchartEnvironment, this.occupationalProfile.getFirstValidMonitoringCode());
        }
    }

    shouldShowCharts(): boolean {
        return this.config.cijfergegevensEnabled && this.occupationalProfile.hasMonitoringCode();
    }

}
